/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import * as apis from '@/apis'
import qs from 'qs'
import { Layout, Menu, Button, Avatar, Table, Divider, Icon, Breadcrumb, message } from 'antd'
import { withQuery } from '@/utils'
import { getAddrText } from '@/utils/regions';
import CallNumber from '@/components/CallNumber'
import * as actions from '@/models/workers/actions'
import styles from './workers.module.scss'

function getColumns(fetch) {
  const dispatch = useDispatch()
  const handle = useCallback((id, type, reject_reason) => {
    apis.handleJoinRequest({
      id,
      type,
      reject_reason
    }).then(() => {
      message.success('已完成')
      fetch()
    }).catch(error => {
      fetch()
      message.error(error.message || '操作失败')
    })
  })
  const showRejeactJoinRequestDialog = useCallback(id => {
    dispatch(actions.showRejeactJoinRequestDialog({
      onSubmit: ({ reject_reason }) => handle(id, 'rejected', reject_reason)
    }))
  })

  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{whiteSpace: 'nowrap'}}>{idx+1}.</div>
    },
    {
      title: '头像',
      render: item => (
        <div>
          {
            item.user && <Avatar shape="square" size={42} src={item.user.avatar} />
          }
        </div>
      )
    },
    {
      title: '申请人',
      render: item => (
        <div>
          <div>{item.realname}</div>
          <div><CallNumber number={item.user.mobile} /></div>
          <div style={{fontSize: 12, color: '#999'}}>{item.identity_number}</div>
        </div>
      )
    },
    {
      title: '家庭住址',
      dataIndex: 'home_address',
      render: addr => (
        <div style={{width: 120}}>{addr || '未填写'}</div>
      )
    },
    {
      title: '个人介绍',
      dataIndex: 'bio',
      render: bio => (
        <div style={{width: 120}}>{bio || '未填写'}</div>
      )
    },
    {
      title: '服务区域',
      dataIndex: 'service_area',
      render: serviceArea => {
        if (!serviceArea.length) {
          return (
            <div>未填写</div>
          )
        }

        return serviceArea.map((item, idx) => (
          <div key={idx}>{getAddrText(item)}</div>
        ))
      }
    },
    {
      title: '身份证',
      render: item => (
        <div>
          <a target="_blank" href={item.id_photo_face}>正面</a>
          <br />
          <a target="_blank" href={item.id_photo_back}>背面</a>
        </div>
      )
    },
    {
      title: '申请时间',
      render: item => (
        <div style={{fontSize: 13}}>
          {dayjs(item.createdAt).format('YYYY-MM-DD HH:mm')}
        </div>
      )
    },
    {
      title: '操作',
      render: item => {
        if (item.status !== 'processing') {
          return (
            <div style={{color: '#949494'}}>
              {item.status === 'rejected'? '已拒绝': '已通过'}
            </div>
          )
        }

        return (
          <div>
            <a onClick={() => handle(item._id, 'completed')}>
              通过
            </a>
            <Divider type="vertical" />
            <a onClick={() => showRejeactJoinRequestDialog(item._id)}>
              拒绝
            </a>
          </div>
        )
      }
    }
  ]
}

function WorkerList(props) {
  const dispatch = useDispatch()
  const { query, history, match, location } = props
  const prevQuery = usePrevious(query)
  const limit = query.limit || 10
  const offset = query.offset || 0
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const pagination = {
    showQuickJumper: true,
    total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }

  const fetch = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit

    setLoading(true)

    apis.joinRequestList()
      .then(result => {
        setLoading(false)
        setList(result.data)
        setTotal(result.total)
      })
  }, [offset, limit])

  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...query,
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-' ) + sorter.field
    }
    window.scrollTop = 0
    history.push(`/workers/request?${qs.stringify(nextQuery)}`)
  })



  const columns = getColumns(fetch)

  useMount(() => {
    fetch(query)
  })

  useUpdateEffect(() => {
    if (prevQuery.offset !== query.offset) {
      window.scrollTop = 0
      fetch(query)
    }
  })

  return (
    <div>
      <Table
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={list}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}></Table>
    </div>
  )
}

export default withQuery(WorkerList)
